import { User } from './../../../core/user/user.types';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { Subject, takeUntil } from 'rxjs';
import { SearchParams } from '../search-params';
import { SearchService } from '../search.service';
import { environment as env } from 'environments/environments';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { StatusStickerComponent } from 'app/modules/GlobalComponents/status sticker.component';
import { Coleccionista, ColeccionistasResponse } from 'app/models/coleccionitas.model';
import { UserAvatarWidgetComponent } from 'app/modules/GlobalComponents/user-avatar-component';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'environments/environments';

@Component({
    selector: 'card-coleccionista',
    templateUrl: 'card-coleccionista.component.html',
    imports:[
        CommonModule,
        MatTableModule,
        MatPaginatorModule,
        MatIconModule,
        MatButtonModule,

        //global componets
        StatusStickerComponent,
        UserAvatarWidgetComponent
    ]
})

export class CardColeccionistaComponent implements OnInit {
    @Input() coleccionistas: ColeccionistasResponse
    displayedColumns: string[] = ['avatar','detalleColeccionista','seccion','actions'];
    //Paginación
    tipoPaginacion:number=environment.TIPOLOGIA_ID_TIPO_PROPIEDAD //Id para paginación de coleccionistas
    @ViewChild(MatPaginator) paginator: MatPaginator;
    pageSizes = 10
    inicio:number = 0
    max:number = 10

     _unsubscribe: Subject<any> = new Subject()
        value:string =  ''
    
    constructor(
        private SearchService: SearchService,
        private router: Router, 
        private activeroute: ActivatedRoute,
    ) {
        this.activeroute.params.pipe(takeUntil(this._unsubscribe)).subscribe(params => {
                  if (params.value) {
                    this.value = params.value;
                  }
                });
     }

    

    ngOnInit() { }

    ngAfterViewInit() {
        this.paginator.page
            .pipe(takeUntil(this._unsubscribe))
            .subscribe(event => {
                const startIndex = event.pageIndex * event.pageSize;
                const endIndex = startIndex + event.pageSize;
                this.inicio = startIndex;
                this.max = endIndex;
                this.search(this.tipoPaginacion , this.inicio, this.max);
            });
    }

    search(tipoPaginacion: number, inicio: number, max: number) {
        let params: SearchParams = {
            tipoPaginacion: tipoPaginacion,
            inicio: inicio,
            max: max,
            asc: false,
            busqueda: this.value
        };
    
        this.SearchService.searchTask(params)
    
    }

    openDetails(coleccionista:Coleccionista ){
        this.router.navigateByUrl(`/coleccionista/${coleccionista.coleccionistaUuid}/${coleccionista.coleccionistaId}`)
    }
}